// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1yGZo","author":"Table_author__r2E_I","authorImage":"Table_authorImage__3aaT1","unreadRow":"Table_unreadRow__25L7v"};